import { FC } from "react";
import { IconPropsType } from ".";

export const CheckMark: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="16"
      height="12"
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1 5.5L5.66667 10L15 1" stroke={props.color} strokeWidth="2" />
    </svg>
  );
};
